import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';

import { OverflowContainer } from '../overflow-tooltip';

export const ProgressStatCard = ({
  onClick,
  progressPercentage,
  progressInfo,
  title,
  subTitle,
}: {
  onClick: () => void;
  progressPercentage: number;
  progressInfo?: string;
  title: string;
  subTitle?: string;
}) => {
  const borderColor = useColorModeValue('gray.300', 'gray.500');
  const progressTextColor = useColorModeValue('gray.700', 'gray.400');

  return (
    <Center
      role="button"
      tabIndex={0}
      border="1px"
      borderColor={borderColor}
      rounded="lg"
      h="135px"
      w="140px"
      p={2}
      cursor="pointer"
      onClick={onClick}
      shadow="base"
    >
      <Stack spacing={2} overflow="hidden">
        <Center>
          <CircularProgress
            value={progressPercentage}
            color="green.400"
            size="65px"
            thickness="5px"
          >
            <CircularProgressLabel color={progressTextColor} lineHeight={3}>
              <Text as="strong" size="xs">
                {Math.round(progressPercentage)}%
              </Text>
              <Text size="xs">{progressInfo}</Text>
            </CircularProgressLabel>
          </CircularProgress>
        </Center>
        <Box w="full">
          <OverflowContainer justify="center">
            <OverflowContainer.Tooltip label={title} fontSize="sm" openDelay={500}>
              <Text weight="semibold" align="center" isTruncated>
                {title}
              </Text>
            </OverflowContainer.Tooltip>
          </OverflowContainer>
          <Text size="xs" align="center">
            {subTitle}
          </Text>
        </Box>
      </Stack>
    </Center>
  );
};
